import { useMemo } from "react"
import _ from 'lodash'
import { useAppSelector } from "../../../redux/hooks"
import { V2L3TodayDetail } from "@fusion-advantage/formrender"
import { appointmentIsToday, datestamp, WorkItemType } from "@fusion-advantage/formlib"

export const LxDashboardTodayDetail = () => {
	const filterByDate = useAppSelector(state => state.dashboardData.filterByDate)
	const todosCount = useAppSelector(state => state.dashboardData.workItems[WorkItemType.Todo].items?.length ?? 0)
	const items = useAppSelector(state => state.dashboardData.workItems[WorkItemType.Appointment].items)
	const notifications = useAppSelector(state => state.dashboardData.dashboardNotifications)
	const datedep = datestamp()
	const [today, todayItems] = useMemo(() => {
		const today = datestamp()
		if(!items) {
			return [today, []]
		}
		if(!filterByDate) {
			return [today, items]
		}
		return [today, items.filter(({item}) => {
			// always today
			return appointmentIsToday(item)
		})]
	}, [datedep, filterByDate, items])
	const summaryLabCounts = useMemo(() => {
		let labs: string[] = []
		todayItems.forEach(({item}) => {
			if(item.EligibleLabs) {
				labs = _.concat(labs, item.EligibleLabs)
			}
		})
		return _.countBy(labs)
	}, [todayItems])
	return (
		<V2L3TodayDetail
			displayDate={today}
			todoCount={todosCount}
			apptCount={todayItems.length}
			labCounts={summaryLabCounts}
			notifications={notifications}
		/>
	)
}
